
//  category: 'Web Development','Data Science','Cloud & DevOps','QA & Testing','Programming','Database',
const courses = [
  // --- EXISTING DATA PROVIDED BY THE USER (FOR CONTEXT) ---
  {
    id: 'full-stack-web-development',
    title: 'Full Stack Web Development',
    category: 'Web Development',
    shortDescription: 'Become a versatile developer with expertise in modern web technologies from frontend to backend.',
    intro: 'This comprehensive program is designed to transform aspiring coders into professional Full Stack Developers. You will learn to build dynamic and responsive web applications from scratch, covering both client-side and server-side technologies, along with database management. Our hands-on approach ensures you gain practical experience with real-world projects.',
    icon: 'FaCode',
    duration: '6 Months',
    delivery: 'Online & Offline',
    features: [
      'Live project development',
      'Dedicated mentorship',
      'Interview preparation',
      'Portfolio building'
    ],
    syllabus: [
      {
        section: 'Module 1: Frontend Development Fundamentals',
        topics: [
          'HTML5 & CSS3: Semantic HTML, Flexbox, Grid, Responsive Design',
          'JavaScript Basics: Variables, Data Types, Operators, Control Flow',
          'DOM Manipulation & Event Handling',
          'ES6+ Features: Arrow Functions, Promises, Async/Await'
        ]
      },
      {
        section: 'Module 2: Advanced Frontend with React.js',
        topics: [
          'React.js Core Concepts: Components, JSX, Props, State',
          'React Hooks: useState, useEffect, useContext, useRef',
          'React Router: Navigation & Routing in SPAs',
          'State Management: Context API, Redux (optional intro)',
          'Frontend Build Tools: Webpack & Babel'
        ]
      },
      {
        section: 'Module 3: Backend Development with Node.js & Express.js',
        topics: [
          'Node.js Fundamentals: Event Loop, Modules, npm',
          'Express.js: Building RESTful APIs, Middleware, Routing',
          'Authentication & Authorization: JWT (JSON Web Tokens)',
          'Error Handling & API Security Best Practices'
        ]
      },
      {
        section: 'Module 4: Database Management & Integration',
        topics: [
          'Introduction to Databases: SQL vs NoSQL',
          'MongoDB: Document Database Concepts, CRUD Operations',
          'Mongoose: ODM for MongoDB & Node.js',
          'PostgreSQL/MySQL Basics (optional intro)',
          'Database Design & Normalization (basic)'
        ]
      },
      {
        section: 'Module 5: Deployment, Testing & Advanced Concepts',
        topics: [
          'Version Control: Git & GitHub Workflow',
          'Testing: Unit Testing with Jest/React Testing Library',
          'Deployment Strategies: Heroku, Netlify, Vercel, AWS S3/EC2',
          'CI/CD Basics (Continuous Integration/Continuous Deployment)',
          'Real-time Capstone Project: Build & Deploy a Full Stack Application'
        ]
      }
    ],
    scope: [
      'Frontend Developer',
      'Backend Developer',
      'Full Stack Developer',
      'MERN Stack Developer',
      'UI/UX Developer',
      'Web Application Developer',
      'JavaScript Developer'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaLaptopCode',
        expertise: 'React, Node.js, MongoDB, AWS',
        bio: 'With over 10 years of experience in web development, Bala has led multiple successful product launches in e-commerce and SaaS industries. His passion lies in simplifying complex concepts and mentoring aspiring developers to build robust, scalable applications.'
      },
      {
        name: 'Ajithkumar',
        icon: 'FaPalette',
        expertise: 'UI/UX, Responsive Design, CSS Frameworks, Accessibility',
        bio: 'Ajithkumar is a seasoned UI/UX specialist who focuses on creating intuitive and visually appealing user interfaces. He brings a wealth of knowledge in design thinking, user research, and ensuring web applications are not only functional but also delightful to use.'
      }
    ],
    isTrending: true,
  },
   {
    id: 'java-programming-fundamentals',
    title: 'Java Programming Fundamentals',
    category: 'Programming',
    shortDescription: 'Master the fundamentals of Java, a versatile and widely-used programming language.',
    intro: 'This course provides a strong foundation in Java programming, covering core concepts from basic syntax to object-oriented principles. It is designed for beginners and aspiring developers looking to build robust and scalable applications.',
    icon: 'FaJava',
    duration: '3.5 Months',
    delivery: 'Online & Offline',
    features: [
      'Strong OOP focus',
      'Hands-on coding labs',
      'Eclipse/IntelliJ usage',
      'Problem-solving skills'
    ],
    syllabus: [
      {
        section: 'Module 1: Java Basics & Environment Setup',
        topics: [
          'Introduction to Java: JVM, JRE, JDK',
          'Setting up Java Development Environment (Eclipse/IntelliJ IDEA)',
          'Variables, Data Types, and Operators',
          'Input/Output using Scanner class',
          'Control Flow: If-Else, Switch, Ternary Operator'
        ]
      },
      {
        section: 'Module 2: Arrays, Loops & Strings',
        topics: [
          'Arrays: Single and Multi-dimensional Arrays',
          'Loops: For Loop, While Loop, Do-While Loop, For-Each Loop',
          'Break, Continue Statements',
          'String Handling: String Class, StringBuffer, StringBuilder',
          'String Methods and Operations'
        ]
      },
      {
        section: 'Module 3: Object-Oriented Programming (OOP) in Java',
        topics: [
          'Classes and Objects: Blueprint, Instantiation',
          'Constructors: Default, Parameterized',
          'Encapsulation: Access Modifiers, Getters and Setters',
          'Inheritance: Single, Multi-level, Hierarchical (extends keyword)',
          'Polymorphism: Method Overloading and Overriding',
          'Abstraction: Abstract Classes and Methods',
          'Interfaces: Defining and Implementing Interfaces'
        ]
      },
      {
        section: 'Module 4: Collections & Exception Handling',
        topics: [
          'Collections Framework: List (ArrayList, LinkedList), Set (HashSet, LinkedHashSet, TreeSet), Map (HashMap, TreeMap)',
          'Generics',
          'Exception Handling: Try-Catch-Finally, Throws, Throw Keywords',
          'Custom Exceptions',
          'File I/O: Reading from and Writing to Files (Byte Stream, Character Stream)'
        ]
      },
      {
        section: 'Module 5: Advanced Java Concepts & Project',
        topics: [
          'Multithreading: Creating Threads, Thread Lifecycle, Synchronization',
          'Synchronization & Deadlock Concepts',
          'Lambda Expressions (Java 8+)',
          'Stream API (Java 8+)',
          'Introduction to JDBC (Java Database Connectivity)',
          'Final Project: Build a small console-based Java application'
        ]
      }
    ],
    scope: [
      'Java Developer (Junior)',
      'Backend Developer (Java)',
      'Automation Engineer (Java)',
      'Android Developer (Foundational)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaUserTie',
        expertise: 'Java, Spring Boot, Microservices, OOP',
        bio: 'Bala is a dedicated Java educator with vast experience in enterprise application development. He focuses on building strong logical reasoning and problem-solving skills, preparing students for real-world coding challenges.'
      }
    ],
    isTrending: true,
  },
  {
    id: 'python-programming-fundamentals',
    title: 'Python Programming Fundamentals',
    category: 'Programming',
    shortDescription: 'Learn Python from scratch, from basic syntax to advanced concepts for various applications.',
    intro: 'This course provides a comprehensive introduction to Python programming, ideal for beginners and those looking to strengthen their foundational knowledge. You will learn core syntax, data structures, object-oriented programming, and practical applications in data analysis, web development, and automation.',
    icon: 'FaPython',
    duration: '3 Months',
    delivery: 'Online & Offline',
    features: [
      'Hands-on coding exercises',
      'Project-based learning',
      'Best practices for clean code',
      'Problem-solving focus'
    ],
    syllabus: [
      {
        section: 'Module 1: Python Basics & Setup',
        topics: [
          'Introduction to Python: History, Features, and Applications',
          'Setting up Python Environment (Anaconda/PyCharm/VS Code)',
          'Variables, Data Types (Numbers, Strings, Booleans)',
          'Operators: Arithmetic, Comparison, Logical, Assignment',
          'Input/Output Operations',
          'Control Flow: If-Else, Elif Statements'
        ]
      },
      {
        section: 'Module 2: Data Structures & Loops',
        topics: [
          'Lists: Creation, Manipulation, List Methods',
          'Tuples: Immutability, When to use Tuples',
          'Dictionaries: Key-Value Pairs, Dictionary Methods',
          'Sets: Unique Elements, Set Operations',
          'Loops: For Loop, While Loop',
          'Break, Continue, Pass Statements'
        ]
      },
      {
        section: 'Module 3: Functions, Modules & Error Handling',
        topics: [
          'Defining Functions: Parameters, Arguments, Return Values',
          'Lambda Functions',
          'Scope of Variables (Local vs. Global)',
          'Modules & Packages: Importing and Creating Your Own',
          'Error Handling: Try-Except Blocks, Finally, Custom Exceptions',
          'File I/O: Reading and Writing Files'
        ]
      },
      {
        section: 'Module 4: Object-Oriented Programming (OOP) in Python',
        topics: [
          'Introduction to OOP Concepts: Class, Object, Encapsulation, Inheritance, Polymorphism',
          'Creating Classes and Objects',
          'Constructors (`__init__`) and Instance Methods',
          'Inheritance: Single, Multiple, Multilevel',
          'Method Overriding and Overloading (Concept)',
          'Abstract Classes and Interfaces (Concept)'
        ]
      },
      {
        section: 'Module 5: Advanced Topics & Project',
        topics: [
          'Generators & Decorators',
          'Working with External Libraries (e.g., NumPy, Pandas Intro)',
          'Virtual Environments',
          'Introduction to Web Scraping (e.g., BeautifulSoup)',
          'Basic Web Development with Flask/Django (Conceptual)',
          'Capstone Project: Build a small Python application'
        ]
      }
    ],
    scope: [
      'Python Developer (Junior)',
      'Data Analyst (Python)',
      'Automation Scripting Specialist',
      'Backend Developer (Python)',
      'AI/ML Enthusiast (Foundational)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaUserTie',
        expertise: 'Python, Data Structures, OOP, Scripting',
        bio: 'Bala is a passionate Pythonista with years of experience in developing robust applications and automating complex tasks. He believes in making programming fun and accessible to everyone, focusing on practical problem-solving.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'react-js-essentials',
    title: 'React JS Essentials',
    category: 'Web Development',
    shortDescription: 'Master the most popular JavaScript library for building modern, interactive user interfaces.',
    intro: 'React.js is the cornerstone of modern web development. This course will take you from the basics of components and JSX to advanced concepts like Hooks and state management. By the end, you will be able to build fast, scalable, and maintainable single-page applications.',
    icon: 'FaCode',
    duration: '2.5 Months',
    delivery: 'Online & Offline',
    features: [
      'Component-based architecture',
      'State management techniques',
      'Single-page application project',
      'Integration with APIs'
    ],
    syllabus: [
      {
        section: 'Module 1: React Fundamentals',
        topics: [
          'Introduction to React: Virtual DOM, JSX, and Components',
          'Functional Components vs Class Components',
          'State and Props: Managing Component Data',
          'Event Handling and Conditional Rendering',
          'React Router for Navigation'
        ]
      },
      {
        section: 'Module 2: React Hooks and Advanced Concepts',
        topics: [
          'State Hooks: `useState` for state management',
          'Effect Hooks: `useEffect` for side effects',
          'Context API for global state management',
          'Custom Hooks and Reusable Logic',
          'Working with Forms and Form Libraries'
        ]
      },
      {
        section: 'Module 3: API Integration & Deployment',
        topics: [
          'Making API calls with `fetch` and `Axios`',
          'Handling Asynchronous Data',
          'Error Handling in React Applications',
          'Introduction to Redux/ Zustand for complex state (conceptual)',
          'Deploying a React App to Netlify/Vercel'
        ]
      }
    ],
    scope: [
      'React Developer',
      'Frontend Developer',
      'UI Developer',
      'Web Application Developer'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaLaptopCode',
        expertise: 'React, JavaScript, Redux, API Integration',
        bio: 'Bala is a senior frontend developer with a deep understanding of the React ecosystem. He has led development teams on major projects and is passionate about teaching clean code principles and modern development workflows.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'node-js-backend-development',
    title: 'Node.js Backend Development',
    category: 'Web Development',
    shortDescription: 'Build fast and scalable server-side applications and RESTful APIs using Node.js and Express.',
    intro: 'This course is for developers who want to dive into backend development with JavaScript. You will learn to use Node.js to build powerful, non-blocking servers and create robust RESTful APIs with the Express framework. The curriculum is project-based, ensuring you gain the practical skills needed to connect a frontend to a database.',
    icon: 'FaServer',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'API development',
      'Database integration (MongoDB)',
      'User authentication',
      'Deployment strategies'
    ],
    syllabus: [
      {
        section: 'Module 1: Node.js & Express Fundamentals',
        topics: [
          'Introduction to Node.js: Event Loop, Modules, npm',
          'Setting up a Node.js project',
          'Introduction to Express.js: Routing, Middleware',
          'Building RESTful APIs: GET, POST, PUT, DELETE requests',
          'Handling Request & Response Objects'
        ]
      },
      {
        section: 'Module 2: Database Integration & Data Modeling',
        topics: [
          'Introduction to MongoDB (NoSQL Database)',
          'Connecting Node.js to MongoDB using Mongoose',
          'CRUD Operations: Create, Read, Update, Delete',
          'Data Validation and Error Handling',
          'Data Modeling Best Practices'
        ]
      },
      {
        section: 'Module 3: Authentication & Security',
        topics: [
          'User Authentication with JSON Web Tokens (JWT)',
          'Password Hashing with `bcrypt`',
          'Middleware for Authentication and Authorization',
          'API Security Best Practices',
          'Handling File Uploads'
        ]
      }
    ],
    scope: [
      'Backend Developer',
      'Node.js Developer',
      'API Developer',
      'Full Stack Developer (Backend focus)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaServer',
        expertise: 'Node.js, Express, MongoDB, REST APIs',
        bio: 'Bala is a full stack developer with a strong focus on backend systems. He has architected and built scalable APIs for a variety of web applications, and his teaching style emphasizes writing clean, efficient, and secure code.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'sql-database-fundamentals',
    title: 'SQL Database Fundamentals',
    category: 'Database',
    shortDescription: 'Learn to design, manage, and query relational databases with Structured Query Language (SQL).',
    intro: 'SQL is the universal language for managing data in relational databases, a critical skill for developers, data analysts, and QA professionals. This course covers everything from basic queries to advanced joins, helping you master data manipulation and retrieval for any application or business need.',
    icon: 'FaDatabase',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'Hands-on SQL practice',
      'Database design principles',
      'Real-world data manipulation scenarios',
      'Practical projects'
    ],
    syllabus: [
      {
        section: 'Module 1: SQL Basics & Data Retrieval',
        topics: [
          'Introduction to Relational Databases & SQL',
          'Setting up a local database (e.g., PostgreSQL or MySQL)',
          'Basic `SELECT` Statements',
          'Filtering Data with `WHERE` Clause',
          'Sorting Results with `ORDER BY`'
        ]
      },
      {
        section: 'Module 2: Data Manipulation & Joins',
        topics: [
          'Inserting, Updating, and Deleting Data',
          'Working with Primary Keys and Foreign Keys',
          '`INNER JOIN`, `LEFT JOIN`, `RIGHT JOIN`',
          'Aggregating Data with `COUNT`, `SUM`, `AVG`, `GROUP BY`',
          'Subqueries and Common Table Expressions (CTEs)'
        ]
      },
      {
        section: 'Module 3: Advanced Concepts & Database Design',
        topics: [
          'Indexing for Performance',
          'Database Schemas and Table Relationships',
          'Normalization Forms (1NF, 2NF, 3NF)',
          'Creating Views, Stored Procedures, and Functions',
          'Practical Project: Design and populate a database for a small business'
        ]
      }
    ],
    scope: [
      'SQL Developer',
      'Database Administrator (Junior)',
      'Data Analyst',
      'Business Intelligence Developer',
      'Backend Developer'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaDatabase',
        expertise: 'SQL, PostgreSQL, Database Design, Performance Tuning',
        bio: 'Bala has over 15 years of experience in database management and data architecture. He has worked with massive datasets and his expertise lies in writing highly performant queries and designing robust database systems.'
      }
    ],
    isTrending: false,
  },
      {
    id: 'software-test-automation',
    title: 'Software Testing',
    category: 'QA & Testing',
    shortDescription: 'Master automated testing tools and frameworks for quality assurance and efficient software delivery.',
    intro: 'Ensure high-quality software delivery by mastering test automation. This comprehensive program covers various testing methodologies, industry-standard tools, and frameworks, enabling you to build robust automated test suites and become an indispensable part of any development team.',
    icon: 'FaCheckCircle',
    duration: '4 Months',
    delivery: 'Online & Offline',
    features: [
      'Practical test scenarios',
      'Framework design',
      'Reporting tools',
      'Job-ready skills'
    ],
    syllabus: [
      {
        section: 'Module 1: Software Testing & Manual Concepts',
        topics: [
          'Software Development Life Cycle (SDLC) & Software Testing Life Cycle (STLC)',
          'Introduction to Manual Testing: Functional, Non-Functional, Regression Testing',
          'Test Case Design Techniques: Equivalence Partitioning, Boundary Value Analysis',
          'Defect Life Cycle & Bug Reporting',
          'Introduction to Test Automation: Benefits, Challenges, and When to Automate'
        ]
      },
      {
        section: 'Module 2: UI Test Automation Principles (Selenium & Playwright Intro)',
        topics: [
          'Programming for Automation: Python/Java overview for test scripting',
          'Selenium WebDriver basics: Concepts, Element Interactions, Locators',
          'Playwright basics: Setup and Core Interactions',
          'Handling Waits & Synchronization in UI Automation',
          'Introduction to Page Object Model (POM)'
        ]
      },
      {
        section: 'Module 3: API & Database Testing Fundamentals',
        topics: [
          'Introduction to APIs: REST & SOAP Web Services',
          'API Testing Concepts and Tools (e.g., Postman)',
          'Basic Automated API Testing principles',
          'SQL Database Fundamentals for Testers: Basic Queries and Data Validation',
          'Connecting to Databases from Test Scripts'
        ]
      },
      {
        section: 'Module 4: Test Frameworks & CI/CD Integration',
        topics: [
          'Test Organization with TestNG/JUnit (Java) or PyTest/Unittest (Python)',
          'Behavior-Driven Development (BDD) Introduction (Cucumber/Behave)',
          'Version Control with Git & GitHub for Test Projects',
          'Integrating Automation Tests into CI/CD Pipelines'
        ]
      },
      {
        section: 'Module 5: Advanced Topics & Capstone Project',
        topics: [
          'Cross-Browser & Parallel Testing Strategies',
          'Test Reporting & Dashboarding',
          'Mocking & Stubbing in Tests',
          'Introduction to Performance Testing',
          'Comprehensive End-to-End Automation Project'
        ]
      }
    ],
    scope: [
      'Automation Test Engineer',
      'QA Engineer',
      'Software Tester',
      'Performance Tester',
      'SDET (Software Development Engineer in Test)',
      'Test Automation Lead (Junior)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaBug',
        expertise: 'Selenium, Playwright, API Testing, Java, Python, BDD',
        bio: 'Bala has over 8 years in QA automation, specializing in building scalable test frameworks for e-commerce and banking applications. He focuses on practical, hands-on training for real-world scenarios, preparing students for immediate industry impact.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'selenium-test-automation',
    title: 'Selenium Test Automation',
    category: 'QA & Testing',
    shortDescription: 'Master browser automation with Selenium WebDriver for robust web application testing.',
    intro: 'Dive deep into Selenium WebDriver, the industry-standard tool for automating web browsers. This course provides hands-on experience in building scalable and maintainable test automation frameworks from scratch, using either Java or Python.',
    icon: 'FaGlobe',
    duration: '3 Months',
    delivery: 'Online & Offline',
    features: [
      'In-depth Selenium API',
      'Framework design patterns',
      'CI/CD integration',
      'Real-world project'
    ],
    syllabus: [
      {
        section: 'Module 1: Selenium Fundamentals & Environment Setup',
        topics: [
          'Introduction to Selenium & its Components (WebDriver, Grid, IDE)',
          'Setting up Development Environment (Java/Python, IDE, Browser Drivers)',
          'WebDriver Basics: Browser Management, Navigation Commands',
          'Locators in detail: ID, Name, ClassName, TagName, LinkText, PartialLinkText, XPath, CSS Selectors',
          'Basic Element Interactions: Click, SendKeys, Clear, GetText, GetAttribute'
        ]
      },
      {
        section: 'Module 2: Advanced Selenium WebDriver Concepts',
        topics: [
          'Handling Waits: Implicit Wait, Explicit Wait (WebDriverWait), Fluent Wait',
          'Handling Special Elements: Alerts, Frames, Windows & Tabs, Dropdowns (Select Class)',
          'Working with Actions Class: Mouse and Keyboard Interactions',
          'Taking Screenshots on Test Failures',
          'File Uploads and Downloads in Selenium'
        ]
      },
      {
        section: 'Module 3: Test Frameworks & Design Patterns',
        topics: [
          'TestNG/JUnit (for Java) or PyTest/Unittest (for Python): Annotations, Assertions, Test Suites',
          'Page Object Model (POM) Design Pattern: Implementation & Best Practices',
          'Data-Driven Testing: Reading Data from Excel, CSV, JSON',
          'Keyword-Driven & Hybrid Frameworks (Introduction and Implementation)',
          'Test Reporting: Extent Reports (Java) / Allure Reports (Python)'
        ]
      },
      {
        section: 'Module 4: Selenium Grid & CI/CD Integration',
        topics: [
          'Introduction to Selenium Grid: Distributed Testing',
          'Setting up and Configuring Selenium Grid (Hub & Nodes)',
          'Cross-Browser Testing with Selenium Grid',
          'Version Control with Git & GitHub for Test Automation Projects',
          'Integrating Selenium Tests with CI/CD Pipelines (Jenkins, GitHub Actions)'
        ]
      }
    ],
    scope: [
      'Selenium Automation Engineer',
      'Web UI Automation Specialist',
      'QA Automation Engineer',
      'SDET (Software Development Engineer in Test)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaRobot',
        expertise: 'Selenium, Java, TestNG, Framework Design',
        bio: 'Bala is a veteran test automation architect with 10+ years of experience in building robust Selenium frameworks. He specializes in Java-based automation and loves optimizing test suites for performance and reliability.'
      }
    ],
    isTrending: true,
  },
  {
    id: 'playwright-test-automation',
    title: 'Playwright Test Automation',
    category: 'QA & Testing',
    shortDescription: 'Build fast, reliable, and powerful end-to-end tests with Microsoft Playwright.',
    intro: 'Master Playwright, the modern automation framework from Microsoft, for highly reliable and fast end-to-end testing of web applications across all major browsers. This course focuses on practical application with JavaScript/TypeScript.',
    icon: 'FaRocket',
    duration: '2.5 Months',
    delivery: 'Online & Offline',
    features: [
      'Cross-browser compatibility',
      'Auto-wait capabilities',
      'Codegen & tracing',
      'Parallel execution'
    ],
    syllabus: [
      {
        section: 'Module 1: Playwright Fundamentals & Setup',
        topics: [
          'Introduction to Playwright: Why Playwright? Features & Architecture',
          'Environment Setup: Node.js, VS Code, Playwright Test Runner',
          'First Test: Launching Browsers, Page Object, Basic Navigations',
          'Playwright Locators: Text, CSS, XPath, getByRole, getByLabel, etc.',
          'Actions: Click, Type, Fill, Select, Hover, etc.'
        ]
      },
      {
        section: 'Module 2: Advanced Playwright Features',
        topics: [
          'Assertions with Playwright-Test Expect API',
          'Handling Waits and Auto-Waiting Mechanism',
          'Working with Frames, Pop-ups, and Dialogs',
          'Screenshot & Video Recording for Debugging',
          'Network Interception & API Mocking',
          'Tracing for Test Debugging'
        ]
      },
      {
        section: 'Module 3: Test Organization & Framework Design',
        topics: [
          'Page Object Model (POM) in Playwright',
          'Test Fixtures & Hooks (beforeEach, afterAll, etc.)',
          'Data-Driven Testing in Playwright',
          'Component Testing with Playwright (Introduction)',
          'Integrating Playwright with CI/CD (GitHub Actions, Jenkins)'
        ]
      },
      {
        section: 'Module 4: Parallelism, Reporting & Best Practices',
        topics: [
          'Parallel Test Execution & Sharding',
          'Cross-Browser Testing Strategies',
          'Test Reporting: HTML Reporter, JSON Reporter, Allure Report',
          'Best Practices for Writing Maintainable & Reliable Playwright Tests',
          'End-to-End Project with Playwright'
        ]
      }
    ],
    scope: [
      'Playwright Automation Engineer',
      'Frontend Test Specialist',
      'SDET (Software Development Engineer in Test)',
      'QA Automation Lead (Playwright)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaDesktop',
        expertise: 'Playwright, JavaScript, TypeScript, CI/CD',
        bio: 'Bala is a cutting-edge test automation engineer with a focus on modern tools like Playwright. He helps teams adopt robust testing strategies that accelerate release cycles and improve software quality.'
      }
    ],
    isTrending: true,
  },
 {
    id: 'api-automation-testing',
    title: 'API Automation Testing',
    category: 'QA & Testing',
    shortDescription: 'Master the art of automated API testing to ensure the reliability and security of web services.',
    intro: 'API testing is a crucial part of modern software development, ensuring that the backend of an application works correctly and securely. This course covers the fundamentals of API architecture and provides hands-on experience using popular tools and frameworks to automate API test cases, preparing you for a specialized QA role.',
    icon: 'FaExchangeAlt',
    duration: '2.5 Months',
    delivery: 'Online & Offline',
    features: [
      'Postman & API fundamentals',
      'Automation with Rest Assured',
      'Integration with CI/CD',
      'Mocking and data handling'
    ],
    syllabus: [
      {
        section: 'Module 1: API Fundamentals & Manual Testing',
        topics: [
          'Introduction to APIs: REST & SOAP',
          'HTTP Methods: GET, POST, PUT, DELETE',
          'API Testing vs UI Testing',
          'Manual API Testing with Postman',
          'Collections, Environments, and Variables in Postman'
        ]
      },
      {
        section: 'Module 2: Automated API Testing',
        topics: [
          'Introduction to a Testing Framework (e.g., Rest Assured)',
          'Setting up the automation environment (Java/Python)',
          'Writing Automated Test Cases for APIs',
          'Assertions and Schema Validation',
          'Handling different request and response formats (JSON, XML)'
        ]
      },
      {
        section: 'Module 3: Advanced Concepts & Project',
        topics: [
          'Data-Driven API Testing',
          'API Chaining and Dependency Management',
          'Authentication and Authorization in API Testing',
          'Integrating API tests into CI/CD pipelines',
          'Comprehensive API Automation Project'
        ]
      }
    ],
    scope: [
      'API Test Automation Engineer',
      'QA Engineer (API focus)',
      'SDET (Software Development Engineer in Test)',
      'Backend Tester'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaCheckCircle',
        expertise: 'API Testing, Rest Assured, Postman, CI/CD',
        bio: 'Bala is a passionate and detail-oriented QA professional who has helped multiple startups build their API testing strategies from the ground up. Her training focuses on practical, real-world testing scenarios and industry best practices.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'etl-data-warehousing-testing',
    title: 'ETL & Data Warehousing Testing',
    category: 'QA & Testing',
    shortDescription: 'Validate data integrity and quality by learning specialized testing techniques for ETL and data warehouses.',
    intro: 'ETL (Extract, Transform, Load) testing is a specialized field that ensures data is correctly moved and transformed from source systems to data warehouses. This course will teach you the methodologies, validation techniques, and SQL skills required to become a proficient ETL tester, a highly valuable and sought-after skill in the data industry.',
    icon: 'FaDatabase',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'Data validation techniques',
      'SQL for data testing',
      'Data warehousing concepts',
      'Real-world test scenarios'
    ],
    syllabus: [
      {
        section: 'Module 1: Introduction to ETL & Data Warehousing',
        topics: [
          'Introduction to ETL Process (Extract, Transform, Load)',
          'Data Warehousing Concepts: OLAP vs OLTP',
          'Data Migration and Data Quality',
          'The Role of an ETL Tester',
          'ETL Testing vs Database Testing'
        ]
      },
      {
        section: 'Module 2: ETL Testing Lifecycle & Techniques',
        topics: [
          'ETL Testing Lifecycle',
          'Data Validation Techniques: Source to Target Count, Data Integrity Checks',
          'Validating Data Transformations',
          'Testing Data Loading and Performance',
          'SQL Queries for Data Validation'
        ]
      },
      {
        section: 'Module 3: Tools & Advanced Concepts',
        topics: [
          'Introduction to ETL Tools (e.g., Informatica, Talend)',
          'Testing with Sample Data and Negative Scenarios',
          'Creating Test Cases for ETL Scenarios',
          'Bug Reporting and Defect Management',
          'Final Project: A complete ETL test cycle for a dataset'
        ]
      }
    ],
    scope: [
      'ETL Tester',
      'Data Tester',
      'QA Engineer (Data focus)',
      'Data Analyst'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaClipboardCheck',
        expertise: 'ETL Testing, SQL, Data Warehousing, Informatica',
        bio: 'Bala is an experienced ETL tester and data quality consultant who has worked with major corporations to ensure the accuracy and reliability of their data pipelines. Her training is built on practical examples and a deep understanding of the data lifecycle.'
      }
    ],
    isTrending: false,
  },
    {
    id: 'jmeter-performance-testing',
    title: 'JMeter Performance Testing',
    category: 'QA & Testing',
    shortDescription: 'Learn to use Apache JMeter to conduct load, stress, and performance testing on web applications.',
    intro: 'Performance is a key factor in user satisfaction. This course teaches you to use JMeter, a powerful open-source tool, to simulate heavy user traffic and test the performance of your applications. You will learn to create detailed test plans, analyze results, and identify performance bottlenecks before they impact your users.',
    icon: 'FaServer',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'Load and stress testing',
      'Scripting and test plan creation',
      'Detailed report analysis',
      'Real-world test scenarios'
    ],
    syllabus: [
      {
        section: 'Module 1: JMeter Fundamentals',
        topics: [
          'Introduction to Performance Testing & JMeter',
          'JMeter Installation and GUI',
          'Creating a Basic Test Plan: Thread Group, Samplers, Listeners',
          'Configuring HTTP Request Defaults',
          'Running and Analyzing a Simple Load Test'
        ]
      },
      {
        section: 'Module 2: Advanced Test Plan Creation',
        topics: [
          'Working with Variables and Parameters',
          'Handling Dynamic Data: Regular Expression Extractor',
          'Assertions to Validate Responses',
          'Handling Cookies and Sessions',
          'Recording Test Scripts with the HTTP(S) Test Script Recorder'
        ]
      },
      {
        section: 'Module 3: Reporting & Best Practices',
        topics: [
          'Running Tests in Non-GUI Mode',
          'Generating HTML Reports',
          'Distributed Load Testing with JMeter',
          'Best Practices for Performance Testing',
          'Final Project: A full performance test of a web application'
        ]
      }
    ],
    scope: [
      'Performance Test Engineer',
      'Load Test Analyst',
      'QA Engineer (Performance focus)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaServer',
        expertise: 'JMeter, Performance Testing, LoadRunner, CI/CD',
        bio: 'Bala is a dedicated performance engineer with over a decade of experience in ensuring the scalability and responsiveness of high-traffic applications. He provides practical, data-driven insights to help students excel in performance testing.'
      }
    ],
    isTrending: false,
  },
   
  {
    id: 'mobile-automation-appium',
    title: 'Mobile Appium Automation',
    category: 'QA & Testing',
    shortDescription: 'Build robust and cross-platform automated tests for native, hybrid, and mobile web apps with Appium.',
    intro: 'Appium is an open-source framework for automating mobile application testing. This course will teach you to write test scripts that work seamlessly across Android and iOS platforms, helping you ensure the quality of mobile applications and advance your career in the booming mobile technology sector.',
    icon: 'FaCheckCircle',
    duration: '3 Months',
    delivery: 'Online & Offline',
    features: [
      'Android & iOS automation',
      'Real device and emulator testing',
      'Gestures & interactions',
      'CI/CD integration for mobile tests'
    ],
    syllabus: [
      {
        section: 'Module 1: Appium Fundamentals & Setup',
        topics: [
          'Introduction to Mobile Automation & Appium',
          'Appium Architecture & Concepts',
          'Environment Setup: Java/Python, Android SDK, XCode (for iOS)',
          'Using the Appium Inspector to locate elements',
          'Basic Test Scripting: Launching Apps, Locating Elements'
        ]
      },
      {
        section: 'Module 2: Advanced Element Handling & Gestures',
        topics: [
          'Element Locators: ID, XPath, Class Name, Accessibility ID',
          'Handling Waits and Synchronizations',
          'Executing Mobile Gestures: Tap, Swipe, Scroll, Pinch',
          'Working with different app types: Native, Hybrid, Mobile Web'
        ]
      },
      {
        section: 'Module 3: Framework Design & CI/CD',
        topics: [
          'Page Object Model (POM) for Mobile',
          'TestNG/JUnit (Java) or PyTest (Python) for test organization',
          'Data-driven testing for mobile',
          'Integrating Mobile Tests with a CI/CD pipeline',
          'Final Project: Automate a full mobile application flow'
        ]
      }
    ],
    scope: [
      'Mobile Automation Engineer',
      'Appium Specialist',
      'QA Engineer (Mobile focus)',
      'SDET (Mobile)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaCheckCircle',
        expertise: 'Appium, Mobile Testing, Android, iOS, CI/CD',
        bio: 'Bala is a certified mobile automation expert who has spent his career building quality assurance processes for leading mobile applications. He provides invaluable insights into the nuances of mobile testing and debugging.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'data-science-ai-ml',
    title: 'Data Science & AI/ML',
    category: 'Data Science',
    shortDescription: 'Unleash the power of data with in-depth training in AI, Machine Learning, and data analytics.',
    intro: 'Our Data Science & AI/ML program is designed to equip you with the skills to analyze complex datasets, build intelligent models, and drive data-driven decisions. From foundational statistics to advanced deep learning, you’ll master the tools and techniques of the future, preparing you for high-demand roles in the analytics industry.',
    icon: 'FaBrain',
    duration: '8 Months',
    delivery: 'Online & Offline',
    features: [
      'Case study approach',
      'Industry-grade tools',
      'Capstone project',
      'Certification assistance'
    ],
    syllabus: [
      {
        section: 'Module 1: Python & Data Fundamentals',
        topics: [
          'Python Programming for Data Science: Basics to Advanced',
          'NumPy for Numerical Computing',
          'Pandas for Data Manipulation & Analysis',
          'Matplotlib & Seaborn for Data Visualization',
          'SQL for Data Retrieval and Database Interaction'
        ]
      },
      {
        section: 'Module 2: Statistics & Exploratory Data Analysis (EDA)',
        topics: [
          'Descriptive Statistics: Measures of Central Tendency & Dispersion',
          'Inferential Statistics: Hypothesis Testing, A/B Testing',
          'Probability Theory',
          'Data Cleaning, Missing Value Imputation, Outlier Detection',
          'Feature Engineering & Selection'
        ]
      },
      {
        section: 'Module 3: Machine Learning Core',
        topics: [
          'Introduction to Machine Learning: Supervised, Unsupervised, Reinforcement',
          'Regression Algorithms: Linear, Polynomial, Ridge, Lasso',
          'Classification Algorithms: Logistic Regression, Decision Trees, Random Forest, SVM',
          'Clustering Algorithms: K-Means, Hierarchical Clustering',
          'Model Evaluation Metrics, Cross-Validation, Hyperparameter Tuning'
        ]
      },
      {
        section: 'Module 4: Deep Learning & Neural Networks',
        topics: [
          'Introduction to Neural Networks: Perceptrons, Activation Functions',
          'Building Neural Networks with TensorFlow/Keras',
          'Convolutional Neural Networks (CNNs) for Image Processing',
          'Recurrent Neural Networks (RNNs) & LSTMs for Sequence Data',
          'Introduction to Transfer Learning'
        ]
      },
      {
        section: 'Module 5: Advanced Topics & Projects',
        topics: [
          'Natural Language Processing (NLP) Fundamentals',
          'Big Data Ecosystem Introduction: Hadoop, Spark (conceptual)',
          'Model Deployment Strategies (basic)',
          'Ethical AI & Bias in ML',
          'Industry Case Studies & Capstone Project'
        ]
      }
    ],
    scope: [
      'Data Scientist',
      'Machine Learning Engineer',
      'Data Analyst',
      'AI Engineer',
      'Business Intelligence Developer',
      'Deep Learning Engineer',
      'NLP Engineer'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaBrain',
        expertise: 'Machine Learning, Deep Learning, Python, NLP',
        bio: 'Bala is a lead Data Scientist with 12+ years of experience in building and deploying AI solutions across finance and healthcare sectors. He has a strong background in predictive modeling, algorithm optimization, and enjoys demystifying complex AI concepts for his students.'
      },
      {
        name: 'Emily Chen',
        icon: 'FaChartLine',
        expertise: 'Data Analysis, SQL, Visualization, Statistics',
        bio: 'Emily is an accompliHed Data Analyst and a passionate educator. Her expertise lies in extracting actionable insights from raw data, building compelling dashboards, and driving data-driven decision-making. He focuses on practical applications and real-world case studies.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'devops-cloud-engineering',
    title: 'DevOps & Cloud Engineering',
    category: 'Cloud & DevOps',
    shortDescription: 'Automate and streamline software development and deployment processes on cloud platforms.',
    intro: 'This program equips you with the skills to bridge the gap between development and operations, making you an invaluable asset in modern tech teams. You will learn to automate infrastructure, build robust CI/CD pipelines, and manage cloud resources effectively, preparing you for highly sought-after DevOps and Cloud Engineer roles.',
    icon: 'FaCloud',
    duration: '5 Months',
    delivery: 'Online & Offline',
    features: [
      'Cloud lab access',
      'Automation scripts',
      'Real-time deployments',
      'Certification prep'
    ],
    syllabus: [
      {
        section: 'Module 1: DevOps Fundamentals & Version Control',
        topics: [
          'Introduction to DevOps Principles & Methodologies',
          'Software Development Life Cycle (SDLC) & Agile',
          'Version Control with Git & GitHub: Branching, Merging, Pull Requests',
          'Linux & Hell Scripting for Automation'
        ]
      },
      {
        section: 'Module 2: Containerization with Docker & Kubernetes',
        topics: [
          'Docker Fundamentals: Images, Containers, Dockerfile, Docker Compose',
          'Container Orchestration: Introduction to Kubernetes',
          'Kubernetes Core Concepts: Pods, Deployments, Services, Namespaces',
          'Helm for Kubernetes Package Management'
        ]
      },
      {
        section: 'Module 3: Cloud Platforms (AWS/Azure) & IaC',
        topics: [
          'Introduction to Cloud Computing & Cloud Models (IaaS, PaaS, SaaS)',
          'AWS Core Services: EC2, S3, VPC, IAM, RDS',
          'Azure Core Services: Virtual Machines, Storage Accounts, Virtual Networks',
          'Infrastructure as Code (IaC): Terraform Basics for Multi-Cloud Provisioning',
          'Cloud Security & Best Practices'
        ]
      },
      {
        section: 'Module 4: CI/CD & Configuration Management',
        topics: [
          'Continuous Integration/Continuous Delivery (CI/CD) Pipelines',
          'Jenkins for CI/CD Automation',
          'Introduction to GitLab CI/CD or GitHub Actions',
          'Configuration Management: Ansible for Server Provisioning & Management',
          'Monitoring & Logging with Prometheus/Grafana (basic)'
        ]
      },
      {
        section: 'Module 5: Project & Advanced Topics',
        topics: [
          'Microservices Architecture Overview',
          'Serverless Computing (AWS Lambda/Azure Functions)',
          'Real-world DevOps Project Implementation',
          'Interview Preparation & Certification Guidance (e.g., AWS Certified DevOps Engineer)'
        ]
      }
    ],
    scope: [
      'DevOps Engineer',
      'Cloud Engineer (AWS Specialist)',
      'Cloud Engineer (Azure Specialist)',
      'Site Reliability Engineer (SRE)',
      'Automation Engineer',
      'Infrastructure Engineer',
      'Cloud Architect (Junior)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaCloud',
        expertise: 'AWS, Kubernetes, CI/CD, Terraform',
        bio: 'Bala is a certified Cloud Architect and DevOps specialist with extensive experience in designing and implementing scalable and resilient cloud infrastructures for Fortune 500 companies. He’s passionate about sharing her practical insights and helping students master complex cloud technologies.'
      },
      {
        name: 'Robert Brown',
        icon: 'FaCogs',
        expertise: 'Azure, Docker, Ansible, Scripting',
        bio: 'Robert is a seasoned DevOps practitioner with a focus on automation and efficient software delivery. He has worked with diverse tech stacks and excels at building robust CI/CD pipelines, making software development faster and more reliable.'
      }
    ],
    isTrending: false,
  },

 
  // --- NEW DATA GENERATED AS PER YOUR REQUEST ---

  {
    id: 'html-css-fundamentals',
    title: 'HTML & CSS Fundamentals',
    category: 'Web Development',
    shortDescription: 'Build the foundation of web pages with core HTML structure and modern CSS styling techniques.',
    intro: 'This course is your first step into web development. You will learn the essential languages that power every website on the internet: HTML for content structure and CSS for visual styling. Through hands-on exercises, you\'ll build static websites, understand responsive design, and create beautiful, professional layouts.',
    icon: 'FaCode',
    duration: '1.5 Months',
    delivery: 'Online & Offline',
    features: [
      'No prior coding knowledge needed',
      'Hands-on projects',
      'Live Q&A sessions',
      'Portfolio-ready website creation'
    ],
    syllabus: [
      {
        section: 'Module 1: HTML5 - Structuring Web Content',
        topics: [
          'Introduction to HTML: Tags, Elements, and Attributes',
          'Semantic HTML5: Header, Footer, Nav, Section, Article',
          'Working with Text, Links, and Images',
          'Creating Lists and Tables',
          'Introduction to Forms and Input Elements'
        ]
      },
      {
        section: 'Module 2: CSS3 - Styling Web Pages',
        topics: [
          'Introduction to CSS: Syntax, Selectors, and Cascading',
          'The Box Model: Margin, Padding, Border',
          'CSS Properties: Color, Background, Typography',
          'Layout Techniques: Display Property, Position Property, Z-Index'
        ]
      },
      {
        section: 'Module 3: Responsive Design & Advanced CSS',
        topics: [
          'Flexbox for one-dimensional layouts',
          'CSS Grid for two-dimensional layouts',
          'Media Queries for responsive design',
          'Introduction to CSS Preprocessors (Sass/LESS)',
          'CSS Animations and Transitions'
        ]
      },
    ],
    scope: [
      'Frontend Designer',
      'Web Content Creator',
      'Web Developer (Foundational)',
      'UI/UX Assistant'
    ],
    trainers: [
      {
        name: 'Ajithkumar',
        icon: 'FaLaptopCode',
        expertise: 'HTML5, CSS3, Responsive Design, UI/UX',
        bio: 'Ajithkumar is a creative and experienced web designer who has a passion for building aesthetically pleasing and user-friendly websites. He specializes in modern CSS techniques and loves to help beginners bring their design ideas to life on the web.'
      }
    ],
    isTrending: false,
  },
  
  {
    id: 'aws-cloud-practitioner',
    title: 'AWS Cloud ',
    category: 'Cloud & DevOps',
    shortDescription: 'Get certified with the foundational knowledge of the Amazon Web Services (AWS) Cloud.',
    intro: 'This course provides a high-level overview of the AWS Cloud, preparing you for the AWS Certified Cloud Practitioner exam. You will learn about core AWS services, cloud architecture principles, security, pricing, and support models, setting the stage for more specialized AWS certifications and roles.',
    icon: 'FaAws',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'Exam-oriented curriculum',
      'Hands-on labs for core services',
      'Certification exam vouchers (optional)',
      'Comprehensive study materials'
    ],
    syllabus: [
      {
        section: 'Module 1: Cloud Concepts Overview',
        topics: [
          'Introduction to Cloud Computing: Benefits & Deployment Models',
          'The AWS Global Infrastructure',
          'Core AWS Services: Compute, Storage, Networking',
          'AWS Shared Responsibility Model'
        ]
      },
      {
        section: 'Module 2: Core AWS Services',
        topics: [
          'Compute: EC2, Lambda, and Elastic Beanstalk',
          'Storage: S3, EBS, EFS',
          'Databases: RDS, DynamoDB, Redshift',
          'Networking: VPC, Subnets, Route Tables'
        ]
      },
      {
        section: 'Module 3: Security, Pricing & Support',
        topics: [
          'AWS Security: IAM, Security Groups, NACLs',
          'Monitoring & Analytics: CloudWatch, CloudTrail',
          'AWS Pricing & Billing Models',
          'AWS Support Plans',
          'Introduction to DevOps on AWS (conceptual)'
        ]
      }
    ],
    scope: [
      'Cloud Practitioner',
      'Solutions Architect (Foundational)',
      'IT Professional transitioning to cloud',
      'Sales & Business Professionals (Cloud focus)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaAws',
        expertise: 'AWS Cloud, Solutions Architecture, Security, DevOps',
        bio: 'Bala is an AWS Certified Solutions Architect with a passion for demystifying cloud technology. He has a track record of helping hundreds of students pass their AWS certification exams and confidently navigate the cloud landscape.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'azure-fundamentals',
    title: 'Azure Fundamentals',
    category: 'Cloud & DevOps',
    shortDescription: 'Gain a solid understanding of cloud concepts and foundational Azure services for a cloud career.',
    intro: 'Microsoft Azure is a leading cloud provider for enterprise solutions. This course is a perfect starting point for anyone new to cloud computing or Azure. It covers fundamental cloud concepts, core Azure services, and a basic understanding of security, privacy, compliance, and pricing, preparing you for the AZ-900 certification exam.',
    icon: 'FaWindows',
    duration: '2 Months',
    delivery: 'Online & Offline',
    features: [
      'Preparation for AZ-900 exam',
      'Hands-on exercises with Azure portal',
      'Access to labs and resources',
      'Comprehensive module quizzes'
    ],
    syllabus: [
      {
        section: 'Module 1: Cloud Concepts',
        topics: [
          'Introduction to Cloud Computing: Benefits & Models',
          'Cloud Services: IaaS, PaaS, and SaaS',
          'Public, Private, and Hybrid Cloud models',
          'Understanding Total Cost of Ownership (TCO)'
        ]
      },
      {
        section: 'Module 2: Core Azure Services',
        topics: [
          'Azure Architecture Components',
          'Compute Services: Virtual Machines, App Service, Functions',
          'Storage Services: Blob, File, Disk Storage',
          'Networking: Virtual Networks, VPN Gateways',
          'Database Services: Azure SQL, Cosmos DB'
        ]
      },
      {
        section: 'Module 3: Security, Privacy & Pricing',
        topics: [
          'Azure Security: Identity and Access Management (IAM), Security Center',
          'Azure Governance and Compliance',
          'Azure Cost Management and Service Level Agreements (SLAs)',
          'Exam review and practice questions'
        ]
      }
    ],
    scope: [
      'Cloud Administrator (Foundational)',
      'Cloud Support Engineer',
      'Azure Administrator (Junior)',
      'IT Professional (Cloud Transition)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaWindows',
        expertise: 'Microsoft Azure, Cloud Security, Infrastructure',
        bio: 'Mark is a Microsoft Certified Trainer and a seasoned cloud professional with years of experience in deploying and managing Azure infrastructures. His training is focused on real-world application and passing certification exams.'
      }
    ],
    isTrending: false,
  },
  {
    id: 'appian-low-code-development',
    title: 'Appian Low-Code Development',
    category: 'Business Process Management',
    shortDescription: 'Accelerate your career by learning to build enterprise-grade applications with Appian\'s low-code platform.',
    intro: 'Appian is a powerful low-code platform used by organizations worldwide to build and automate business processes. This course will teach you how to model processes, design user interfaces, manage data, and integrate with external systems, empowering you to build powerful applications without writing extensive code.',
    icon: 'FaCode',
    duration: '3 Months',
    delivery: 'Online & Offline',
    features: [
      'Low-code platform mastery',
      'Business process modeling',
      'UI/UX design with Appian',
      'Project-based learning'
    ],
    syllabus: [
      {
        section: 'Module 1: Appian Platform Fundamentals',
        topics: [
          'Introduction to Low-Code Development & Appian',
          'Navigating the Appian Designer and Environment',
          'Creating Applications, Records, and Reports',
          'User Management and Security'
        ]
      },
      {
        section: 'Module 2: Process Modeling & Automation',
        topics: [
          'Designing and Executing Business Processes',
          'Working with Gateways, Events, and Flows',
          'Using Expressions and Variables',
          'Introduction to Robotic Process Automation (RPA)'
        ]
      },
      {
        section: 'Module 3: User Interface & Integration',
        topics: [
          'Building User Interfaces with SAIL',
          'Creating Forms and Dashboards',
          'Introduction to Integrations with Connected Systems',
          'Error Handling and Deployment Best Practices'
        ]
      }
    ],
    scope: [
      'Appian Developer',
      'Low-Code Developer',
      'Business Process Analyst',
      'Solutions Consultant'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaUserTie',
        expertise: 'Appian Development, Process Automation, UI Design',
        bio: 'Bala is a certified Appian developer with years of experience in creating and automating complex business processes for large enterprises. He enjoys showing how to leverage low-code platforms to deliver solutions quickly and efficiently.'
      }
    ],
    isTrending: false,
  },
    {
    id: 'salesforce-admin-developer',
    title: 'Salesforce Admin & Developer',
    category: 'CRM & Business Applications',
    shortDescription: 'Become a Salesforce professional by mastering administration and low-code development on the platform.',
    intro: 'Salesforce is the world\'s leading customer relationship management (CRM) platform. This dual-track course will give you the skills to manage the platform as an administrator and build custom applications as a developer, opening up a world of career opportunities in a high-demand field.',
    icon: 'FaCloud',
    duration: '4 Months',
    delivery: 'Online & Offline',
    features: [
      'Admin & development training',
      'Hands-on labs on Trailhead',
      'Real-world business case studies',
      'Certification exam prep'
    ],
    syllabus: [
      {
        section: 'Module 1: Salesforce Administration Essentials',
        topics: [
          'Introduction to the Salesforce Platform & CRM concepts',
          'User Management & Security',
          'Data Model & Custom Objects',
          'Automation with Process Builder, Flow, and Workflow Rules',
          'Reports & Dashboards'
        ]
      },
      {
        section: 'Module 2: Developer Fundamentals (Declarative & Programmatic)',
        topics: [
          'Introduction to Apex Programming Language',
          'Building Custom User Interfaces with Lightning App Builder',
          'Apex Triggers & Classes (Basics)',
          'SOQL & SOSL for Data Queries',
          'Introduction to Lightning Web Components (LWC)'
        ]
      },
      {
        section: 'Module 3: Integration & Deployment',
        topics: [
          'Data Management: Data Loader and Import Wizards',
          'Sandbox Environments & Deployment Strategies',
          'Integration with External Systems (conceptual)',
          'Project: Build and deploy a simple custom application on Salesforce'
        ]
      }
    ],
    scope: [
      'Salesforce Administrator',
      'Salesforce Developer (Junior)',
      'Salesforce Consultant',
      'Business Analyst (Salesforce)'
    ],
    trainers: [
      {
        name: 'Bala',
        icon: 'FaServer',
        expertise: 'Salesforce Admin, Apex, LWC, Integrations',
        bio: 'Bala is a Certified Salesforce Administrator and Platform Developer with over a decade of experience in the CRM space. He has a deep understanding of business processes and a knack for creating elegant solutions on the Salesforce platform.'
      }
    ],
    isTrending: false,
  },

  
];
export default courses;